import type { ComponentProps } from 'react';
import { FieldInfo, useFieldContext } from './shared';
import { Label } from '../label';
import { Input } from '../input';
import { formatDatetime } from '../../lib/utils';

export default function DateTimeField({ label, className, ...props }: ComponentProps<'input'> & { label: string }) {
	const field = useFieldContext<string | null | undefined>();

	return (
		<div className={className}>
			<div className="text-muted-foreground relative">
				{label && (
					<Label
						data-slot="form-label"
						data-error={field.state.meta.isTouched && !field.state.meta.isValid}
						className="data-[error=true]:text-destructive floating pointer-events-none w-full truncate px-3.5 py-[17px]"
						htmlFor={field.name}
					>
						{label}
					</Label>
				)}
				{/* Add empty placeholder to avoid css floating label to overlap with input text */}
				<Input
					placeholder=""
					type="datetime-local"
					id={field.name}
					name={field.name}
					value={field.state.value ? formatDatetime(field.state.value) : ''}
					onBlur={field.handleBlur}
					onChange={(e) => field.handleChange(e.target.value ? new Date(e.target.value).toISOString() : null)}
					className="text-foreground h-12 px-3 pt-4 pb-0"
					{...props}
				/>
			</div>
			<FieldInfo fieldState={field.state} />
		</div>
	);
}
